export const shorten = (text: string) => {
  if (!text) return ''
  if (text.length < 28) return text
  let shortenedText = text.substring(0, 25)
  const lastSpace = shortenedText.lastIndexOf(' ')
  if (lastSpace !== -1) {
    shortenedText = shortenedText.substring(0, lastSpace)
  }
  shortenedText += '...'
  return shortenedText
}
